export type { FeaturedAndSortedPortalsUIState } from './reducer';
export { featuredAndSortedPortalsReducer } from './reducer';
